var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeviceRefreshing = function SvgDeviceRefreshing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.808 2.212A7.508 7.508 0 0 1 15 7.538a7.493 7.493 0 0 1-1.511 4.527l1.422 1.432h-3.728V9.744l1.241 1.25a6.01 6.01 0 0 0 1.085-3.456 6.013 6.013 0 0 0-1.755-4.265 5.931 5.931 0 0 0-6.137-1.456L5.147.392a7.411 7.411 0 0 1 7.661 1.82zm-9.08 3.029L2.564 4.069a6.016 6.016 0 0 0-1.039 3.393c0 1.61.624 3.125 1.755 4.266a5.934 5.934 0 0 0 6.137 1.455l.472 1.424a7.42 7.42 0 0 1-7.663-1.819A7.513 7.513 0 0 1 .034 7.463c0-1.63.518-3.177 1.466-4.464L0 1.488h3.728v3.753z",
    fill: "#EDBB1D",
    fillRule: "evenodd"
  })));
};

export default SvgDeviceRefreshing;